import { Charity } from '../types/charities';

export interface CharityStatus {
  value: 'Used' | 'Active' | 'Pending' | 'Non active';
  type: 'switcher' | 'string';
}
export const getCharityStatus = (charity: Charity): CharityStatus => {
  const today = new Date();
  //   if (charity.startDate) {
  //     const couponStartDate = new Date(charity.startDate);
  //     if (couponStartDate > today) {
  //       return {
  //         value: "Pending",
  //         type: "string",
  //       };
  //     }
  //   }
  if (!charity.isActive) {
    return {
      value: 'Non active',
      type: 'switcher',
    };
  }

  return {
    value: 'Active',
    type: 'switcher',
  };
};
export const getCharitiesPageCharityStatus = (
  charity: Charity
): CharityStatus => {
  const today = new Date();
  //   if (charity.startDate) {
  //     const couponStartDate = new Date(charity.startDate);
  //     if (couponStartDate > today) {
  //       return {
  //         value: "Pending",
  //         type: "string",
  //       };
  //     }
  //   }
  if (!charity.isActiveOnCharityPage) {
    return {
      value: 'Non active',
      type: 'switcher',
    };
  }

  return {
    value: 'Active',
    type: 'switcher',
  };
};
export const getCheckoutCharityStatus = (charity: Charity): CharityStatus => {
  const today = new Date();
  //   if (charity.startDate) {
  //     const couponStartDate = new Date(charity.startDate);
  //     if (couponStartDate > today) {
  //       return {
  //         value: "Pending",
  //         type: "string",
  //       };
  //     }
  //   }
  if (!charity.isActiveOnCheckoutPage) {
    return {
      value: 'Non active',
      type: 'switcher',
    };
  }

  return {
    value: 'Active',
    type: 'switcher',
  };
};
